export const CLIENT_TRANSACTIONS_PAGE_SIZE_OPTIONS = [10, 20];
export const DEFAULT_CLIENT_TRANSACTIONS_PAGE_SIZE = 10;

export const getClientTransactionTotalPages = (
  items,
  pageSize = DEFAULT_CLIENT_TRANSACTIONS_PAGE_SIZE
) => {
  const totalItems = Array.isArray(items) ? items.length : 0;
  if (pageSize <= 0) return 1;
  return Math.max(1, Math.ceil(totalItems / pageSize));
};

export const paginateClientTransactions = (
  items,
  page,
  pageSize = DEFAULT_CLIENT_TRANSACTIONS_PAGE_SIZE
) => {
  if (!Array.isArray(items) || pageSize <= 0) return [];
  const totalPages = getClientTransactionTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
};

export const clientTransactionsRangeForPage = (
  items,
  page,
  pageSize = DEFAULT_CLIENT_TRANSACTIONS_PAGE_SIZE
) => {
  if (!Array.isArray(items) || items.length === 0 || pageSize <= 0) {
    return { start: 0, end: 0 };
  }
  const totalPages = getClientTransactionTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, items.length);
  return { start, end };
};

const formatRecordType = (type) => {
  if (type === "purchase") return "Purchase";
  if (type === "mpesa_payment") return "M-Pesa Payment";
  return "Payment";
};

const formatMethod = (record) => {
  return (
    record.paymentMethod ||
    record.paymentMode ||
    record.Mode ||
    (record.type === "purchase" ? "Credit" : "Unspecified")
  );
};

const getDateKey = (dateValue) => {
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().split("T")[0];
};

export const buildClientTransactionChartData = (transactions) => {
  const safeTransactions = Array.isArray(transactions) ? transactions : [];
  const litersByDayMap = new Map();
  const recordTypeMap = new Map();
  const methodMap = new Map();

  safeTransactions.forEach((record) => {
    const typeLabel = formatRecordType(record.type);
    const methodLabel = formatMethod(record);
    recordTypeMap.set(typeLabel, (recordTypeMap.get(typeLabel) || 0) + 1);
    methodMap.set(methodLabel, (methodMap.get(methodLabel) || 0) + 1);

    const liters = parseFloat(record.quantity ?? 0) || 0;
    const dayKey = getDateKey(record.date);
    if (liters > 0 && dayKey) {
      litersByDayMap.set(dayKey, (litersByDayMap.get(dayKey) || 0) + liters);
    }
  });

  const sortByValueDesc = (a, b) => b.value - a.value;

  return {
    litersByDay: Array.from(litersByDayMap, ([day, liters]) => ({
      day,
      liters: Number(liters.toFixed(2)),
    })).sort((a, b) => new Date(a.day) - new Date(b.day)),
    recordTypeDistribution: Array.from(recordTypeMap, ([name, value]) => ({
      name,
      value,
    })).sort(sortByValueDesc),
    methodDistribution: Array.from(methodMap, ([name, value]) => ({
      name,
      value,
    })).sort(sortByValueDesc),
  };
};
